import { render, staticRenderFns } from "./WaterQuality.vue?vue&type=template&id=013c7051&"
import script from "./WaterQuality.vue?vue&type=script&lang=js&"
export * from "./WaterQuality.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports